export default {
  //Slovenia sl(languagecode) SI(countryCode) Slovenija / Slovenščina
  LandingPage: {
    intro_sub:
      'Podarite odpadni embalaži novo življenje in sodelujte pri varovanju okolja.',
    title: 'Samsung Upcycle-Packaging',
    sequence1_1: 'Pridružite se nam pri zmanjševanju odpadkov',
    sequence1_2:
      'za trajnostno okolje, tako da embalažo svojega izdelka preoblikujete v uporabne predmete. Pomaknite se navzdol, če želite narediti vaš prvi korak.',
    sequence2_1: 'Predstavljamo Samsung Upcycle-Packaging',
    sequence2_2:
      'To je škatla za izdelka, ki je bila posebej zasnovana z namenom večvrednostnega recikliranja, za vaš prispevek k okolju. Izdelajte raznolike predmete za vaše gospodinjstvo iz embalaže za izdelka.',
    sequence3_1: 'Sledite natisnjenim pikam na embalaži',
    sequence3_2:
      'Izrežite embalažo po navodilih in sestavite dele ter iz njih ustvarite osupljiv predmet.',
    sequence4_1: 'Izberite predmet, ki ga želite ustvariti',
    sequence4_2:
      'Preletite seznam in izberite model izdelka, ki ga imate na embalaži. Nato poiščite razne možnosti oblikovanja. Naj se vaša ustvarjalna pot začne s predmetom, ki ga želite ustvariti.',
    selectBox: 'Izberite svoj izdelka',
    moreActivity:
      "Za več informacij o trajnostnih dejavnostih družbe Samsung",
    OLED: 'OLED',
    QLED8K: 'QLED', //update
    UHD: 'UHD', //update
    FHD: 'FHD',
    HD: 'HD',
    theFrame: 'The Frame', //update
    theSerif: 'The Serif', //update
    theSero: 'The Sero', //update
    theTerrace: 'The Terrace', //update
    thePremiere: 'The Premiere', //update
    Monitors: 'Monitors', //update
    OdysseyArk:"Odyssey Ark",
    QSoundbar: 'Q Soundbar', //update
    Soundbar: 'Soundbar', //update
    SoundbarSet01:'Soundbar Set 1',
    SoundbarSet02:'Soundbar Set 2',
    TheTerraceSoundbar:'The Terrace Soundbar',
    Soundtower:'Sound Tower',
    BespokeJet: 'BESPOKE Jet\n (Jet)',
    BespokeJetStation:'BESPOKE Jet\n (Clean Station™)',
    BespokeJetNCleanStation : 'BESPOKE Jet&\nClean Station™',
    BespokeJetNCleanStation2 : 'BESPOKE Jet&Clean Station™',
    BespokeCube53:'BESPOKE Cube™ AIR\n(53㎡)',
    BespokeCube70:'BESPOKE Cube™ AIR\n(70㎡)',
    BespokeCube106:'BESPOKE Cube™ AIR\n(106㎡)',
    BespokeCube123:'BESPOKE Cube™ AIR\n(123㎡)',
    Qooker:'Qooker',
    BespokeSlim:'BESPOKE \nSlim',
    TheFreeStyle:"The Freestyle",
    BespokeSlimCleanStation:"BESPOKE Slim&Jet\n(Clean Station™)",
    JetCleanStation:"Jet&\nClean Station™",
    JetCleanStation2:"Jet&Clean Station™",
    BlueSky:"BlueSky \n5500",
    BlueSky3000:"BlueSky \n3000",
    BlueSky3100:"BlueSky \n3100",
    BlueSky5000:"BlueSky \n5000",
    BespokeJetbot:"BESPOKE\n Jet Bot",
    BespokeJetbot2:"BESPOKE Jet Bot",
    BespokeJetbotPlus:"BESPOKE\n Jet Bot+",
    BespokeJetbotPlus2:"BESPOKE Jet Bot+",
    BespokeJetbotAI:"BESPOKE\n Jet Bot AI",
    BespokeJetbotAI2:"BESPOKE Jet Bot AI",
    Canister01:"Canister \n01",
    Canister02:"Canister \n02",
    Jupiter:"Vacuum \nCleaner",
    ref_cube:"BESPOKE Cube",
    WaterPurifier:"Water Purifier",
    LATIN:"LATIN",
    LATIN10:"LATIN10",
    MIRROR:"MIRROR",
    MW5100J:"MW5100J",
    STENA:"STENA",
    // moreActivityLink:
    //   'https://www.samsung.com/si/sustainability/overview/',
    // moreActivityLink:'https://www.samsung.com/si/aboutsamsung/sustainability/strategy/',
    moreActivityLink: 'https://www.samsung.com/si/sustainability/overview/',
    footer: `
    avtorske pravice © 2019-2021 SAMSUNG Vse pravice pridržane.`,
  },
  ProductPage: {
    selectDesign: 'Izberite obliko, ki jo želite ustvariti',
    selectDesignDezeen: 'Samsung X Dezeen', //update
    selectDesignSoccer: 'Samsung X Football', 
    tvConsole: 'TV element',
    StorageBox: 'Škatla za shranjevanje',
    MagazineRack: 'Stojalo za revije',
    CatHouse: 'Hiša za mačke',
    CatTunnel: 'Tunel za mačke',
    BookShelf: 'Knjižna polica',
    DeskShelf: 'Namizna polica',
    BlackRhino: 'Ogrožene živali \n – črni nosorog', //update
    PolarBear: 'Ogrožene živali \n – polarni medved', //update
    SeaTurtle: 'Ogrožene živali \n– morska želva', //update
    TheRider: 'Jahalni konjiček', //update
    Kibe: 'Kibe predalnik', //update
    Tessellate: 'Modularna mizica', //update
    Twist: 'Twist košara', //update
    AlexCouchArmTable: 'Alex mizica \n za kavč', //update
    BlastOffClubHouse: 'Igralna hišica \n v obliki rakete', //update
    KinokoTable: 'Kinoko miza', //update
    Magnuss: 'Magnuss mizica', //update
    GIO: 'Gio vaza in miza', //update
    PostCardPlanter: 'Stojalo za \n razglednice', //update
    SneakerRack: 'Predalnik za \n superge', //update
    TheSoban: 'Nizka mizica Soban', //update
    ToolBox: 'Škatla za orodje', //update
    DeskStationary: 'Škatla za pisarniški material',
    CoinBank: 'Hranilnik',
    MobileScanner:'Stojalo za čitalnik pametnih telefonov',
    TabletScanner:'Stojalo za čitalnik tabličnih računalnikov',
    PetStairs:'Stopnice za hišne ljubljenčke',
    PetFurniture: 'Pet Friendly Furniture',
    ShoeRackA:'Shoe Rack_A',
    ShoeRackB:'Shoe Rack_B',
    WineRackDog:'Wine Rack Dog',
    WineRack:'Wine Rack',
    mins: 'minut',
    all:'ALL',
    in: 'v',
    inOnly: 'v samo',
    allBoxSize: 'Vse velikosti škatel',
    soccergoalpost:'Mini Soccer Goal Post',
   soccerboard:'Table Soccer Board',
   sixpackcarrier:'Six Pack Carrier',
   trophytable:'Trophy Cup Table',
   megaphone:'Cheer Megaphone',
   FreestyleBear:'Small \n Animals \n Polar Bear',
   FreestyleRay:'Small \n Animals \n Ray',
   FreestyleRhino:'Small \n Animals \n Black Rhino',
   FreestyleSeahorse:'Small \n Animals \n See Horse',
   FreestyleWhale:'Small \n Animals \n Whale',
   Mickey:'Mickey Mouse',
   Pluto:'Pluto',
   Diseny:'Samsung X Disney'
  },
  DetailGuidePage: {
    1:'1',
    2:'2',
    3:'3',
    instructions: 'navodila',
    prepare: 'Pripravite škatlo',
    LetsDesign: "Začnimo oblikovati",
    drawParts: 'Narišite dele na škatlo',
    note1: 'Prosimo upoštevajte, da je lahko grafični položaj odvisen od države in velikosti',
    note2: 'Najprej naredite celotno skico, da se bo prilegala škatli',
    numberSpace: 'število = presledki med pikami',
    diagonal: 'diagonalno',
    LEFT: 'LEVI (del)',
    RIGHT: 'DESNI (del)',
    TOP: 'ZGORNJI (del)',
    TOP1: 'ZGORNJI (del) 1',
    TOP2: 'ZGORNJI (del) 2',
    BACK: 'ZADNJI (del)',
    MIDDLE: 'SREDNJI (del)',
    MIDDLE2: 'SREDNJI (del) 2',
    BOTTOM: 'SPODNJI (del)',
    FRONT: 'SPREDNJI (del)',
    SIDE: 'STRANSKI (del)',
    secondSIDE: 'DRUGI STRANSKI (del)',
    secondSIDE1: 'DRUGI STRANSKI (del) 1',
    secondSIDE2: 'DRUGI STRANSKI (del) 2',
    LEG: 'NOGA (del)', //update
    JOINT: 'SKLEP (del)', //update
    FACE: 'OBRAZ (del)', //update
    DRAWERBOTTOM: 'SPODNJI DEL PREDALA (del)', //update
    DRAWERSIDE: 'STRANSKI DEL PREDALA (del)', //update
    NOSE: 'NOS (del)', //update
    HANDLE: 'ROČAJ (del)', //update
    BOTTOMSIDE: 'SPODNJA STRAN (del)', //update
    TOPSIDE: 'ZGORNJA STRAN (del)', //update
    WING: 'KRILO (del)', //update
    cutAndAssemble: "Izrežimo in sestavimo",
    beCareful: 'Pazite, da se ne poškodujete pri uporabi rezalnika',
    cutOutParts: 'Izrežite dele',
    assemble: 'Sestavite',
    Assemblyguide: 'Navodila za sestavo', //update
    fold: 'Primer prepogibanja',
    foldGuide: 'Uporabite rob pohištva pri prepogibanju kartona',
    foldGuideDezeen:
      'Nekajkrat z orodji za prepogibanje pritisnite na pikčasto črto na kartonu, da se bo karton upognil', //update
    glue: 'Na površino enakomerno nanesite lepilo ali lepilni trak', //update
    cable: 'Za povezavo uporabite kabelske vezi ali vrvice', //update
    done: 'Končano!',
    goBack: 'Vrnite se na glavni meni',
  },
  CautionPage: {
    CAUTION: 'OPOZORILO',
    needItem: 'Potrebovali boste naslednje predmete',
    children: 'Otroci morajo biti v spremstvu staršev',
    mat:
      'Prosimo, da na tla položite oblogo, da preprečite praske, ki bi nastale zaradi dela',
    doNotPutHeavyThing:
      'Ne stopite in se ne usedite na to pohištvo ter nanj ne položite težkih predmetov',
    doNotThrow:
      'Ne mečite ali brcajte pohištva proti čemurkoli, niti proti ljudem ali živalim',
    stayAwayFlame: 'Izogibajte se ognju',
    stayAwayWater: 'Ne približujte se vodi ali vlagi',
    mayDamaged: '* Škatla za televizor se je morda lahko poškodovala med dostavo',
    companyDoestResponsible:
      '* Podjetje ne odgovarja zaradi okvar ali poškodb, ki nastanejo pri tem delu',
    cannotBeReturned:
      '* Izdelka s poškodovano škatlo ni možno vrniti zaradi slabe kakovosti',
    understand: 'V redu, razumem',
  },
  PrivacyPolicy: {
    title: 'Privacy policy',
  },
  GoingGreen: {
    visual: {
      title: 'Prehod na zeleno',
      text1:
        'Za večino embalaže za televizorje smo uporabili manj papirja in črnila v primerjavi z našimi predhodnimi embalažami ter se tako približali naši zavezi k trajnosti',
      text2:'',
      text2_special:
        '(* Zgoraj navedeno ne velja za določene modele, vključno z Lifestyle televizorji.)',
      text3: 'Označite spodnje gumbe, če želite odkriti več',
    },
    greenIn: {
      title: 'Prehod na zeleno pri embalažah za televizorje',
      subtitle1: 'Iskanje informacij o izdelku',
      subtitle2: 'Večvrednostno recikliranje eko embalaže',
      desc: 'Poiščite ime modela za več informacij',
      descM: '* Slikajte številko modela televizorja',
      guide: 'ime modela',
      button: 'Posnemite fotografijo',
      button2: 'Pojdite na izdelavo izdelkov',
      product_info: 'Informacije o izdelku',
    },
    search: {
      guide: 'Iskanje..',
      noResult: 'Ni zadetkov',
      more: 'VEČ',
      search: 'Iskanje',
      retake: 'Naredi ponovno',
      result: 'Rezultat',
    },
    photo: {
      guide1: 'V polje vnesite ime modela televizorja',
      guide2: '(npr. Q800A, UT7000, RU7100 itd.)',
    },
  },
  searchCountrySelect: 'Izberite državo za iskanje'
};
